import { CategoryCompactType } from 'routes/Integrations/helpers/types'
import {
  getReadableCategoryName,
  setFilteredIntegrationsCount,
} from 'routes/Integrations/helpers'

export const IntegrationsCategoriesSelectItem = ({
  item,
  filteredCategories,
  loading,
}: {
  item: CategoryCompactType
  filteredCategories: CategoryCompactType[]
  loading: boolean
}) => {
  const { category } = item

  return (
    <option value={category || ''}>
      {getReadableCategoryName(category)}{' '}
      {!loading &&
        `(${setFilteredIntegrationsCount(item, filteredCategories)})`}
    </option>
  )
}
